const textEncoder = new TextEncoder();
export async function sha256Hex(input: string | Uint8Array | null | undefined) {
    let result = '';
    for (const byte of await sha256(input)) {
        result += byte.toString(16).padStart(2, '0');
    }
    return result;
}
export async function sha256(input: string | Uint8Array | null | undefined) {
    if (input === null || input === undefined) {
        input = new Uint8Array();
    } else if (typeof input === 'string') {
        input = textEncoder.encode(input);
    }
    return new Uint8Array(await window.crypto.subtle.digest('SHA-256', input));
}
